import context from '@/context'
import { serverErrorHandler } from '@/utils/serverErrorHandler'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import getComponentKey from '@/utils/getComponentKey'

export const initialState = {
  error: null,
  creating: false,
  created: false,

  ticket: null,
  fetching: false,
  gridKey: getComponentKey()
}

export const actionTypes = {
  Fetching: 'myTickets/fetching',
  Fetched: 'myTickets/fetched',
  Error: 'myTickets/errorOccurred',

  Creating: 'myTickets/creating',
  Created: 'myTickets/created'
}

export const actionCreators = {
  createTicket: (ticket, dialogUid) => (dispatch) => {
    dispatch({ type: actionTypes.Creating })
    context.api.ticketService.createTicket(ticket)
      .then(response => {
        dispatch({ type: actionTypes.Created, data: { ...ticket, id: response } })
        dispatch(dialogActions.closeDialog(dialogUid))
      }).catch(serverErrorHandler(error => dispatch({ type: actionTypes.Error, error })))
  },

  get: (id) => (dispatch) => {
    dispatch({ type: actionTypes.Fetching })
    context.api.ticketService.get(id)
      .then(response => {
        dispatch({ type: actionTypes.Fetched, data: response })
      })
      .catch(error => {
        dispatch({ type: actionTypes.Error, error })
      })
  },
  clearError: () => (dispatch) => {
    dispatch({ type: actionTypes.Error, error: null })
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.Creating: return { ...state, creating: true }
    case actionTypes.Created: return { ...state, creating: false, gridKey: getComponentKey() }
    case actionTypes.Error: return { ...state, creating: false, fetching: false, error: action.error }
    case actionTypes.Fetching: return { ...state, fetching: true }
    case actionTypes.Fetched: return { ...state, fetching: false, ticket: action.data }

    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/store/MyTickets.js